<template>

<!-- 修改课程封面表单 -->
<el-dialog
    v-model="editCourseImgForm"
    title="修改课程封面"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="courseImgFile" class="col-sm-2 col-form-label">封面</label>
        <div class="col-sm-9">
          <input
            type="file"
            class="form-control"
            id="courseImgFile"
            />
            <input type="hidden" id="courseImg" :value="courseImg">
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editCourseImgForm = false">取消</el-button>
        <el-button type="submit" @click="editCourseImgOK();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>


  <div class="container introBack">
    <h6 style="font-weight:bold">基本信息</h6>
    <el-row :gutter="20">
    
    <el-col :span="12" class="colBorder">
        <span class="courseFont">课程封面:</span>
        <img :src="course && course.courseImg" class="form-control courseImg" @click="editCourseImg(course.courseImg);">
    </el-col>


    <el-col :span="10" class="colBorder">
        <span class="courseFont">课程描述:</span>
        <textarea class="courseValue form-control" rows="6" id="courseDes" :value=" course && course.describes" :disabled="courseDesFlag"></textarea>
    </el-col>
    <el-col :span="1" class="colBorder">
        <span class="disableFont">_</span>
        <el-button type="primary" icon="Edit" class="form-control" v-if="courseDesFlag" @click="courseDesFlag = false" plain />
        <el-button type="success" icon="Finished" class="form-control" v-if="!courseDesFlag" @click="editCourseDes()" plain />
    </el-col>


    <el-col :span="10" class="colBorder">
        <span class="courseFont">CourseId:</span>
        <span class="courseValue form-control">{{ course && course.courseId }}</span>
    </el-col>
    <el-col :span="2" class="colBorder"></el-col>

    <el-col :span="10" class="colBorder">
        <span class="courseFont">课程名称:</span>
        <input type="text" class="courseValue form-control" id="courseName" :value="course && course.courseName" :disabled="courseNameFlag"/>
    </el-col>
    <el-col :span="1" class="colBorder">
        <span class="disableFont">_</span>
        <el-button type="primary" icon="Edit" class="form-control" v-if="courseNameFlag" @click="courseNameFlag = false" plain />
        <el-button type="success" icon="Finished" class="form-control" v-if="!courseNameFlag" @click="editCourseName()" plain />
    </el-col>


    <el-col :span="10" class="colBorder">
        <span class="courseFont">课程人数:</span>
        <span class="courseValue form-control">{{ course && course.headCount }}人</span>
    </el-col>
    <el-col :span="2" class="colBorder"></el-col>

    <el-col :span="10" class="colBorder">
        <span class="courseFont">是否热门课程:</span>
        <span class="courseValue form-control" v-if="course && course.isHot <= 0"> 否</span>
        <span class="courseValue" v-if="course && course.isHot >= 1">
            <el-button type="danger"><el-icon><TrophyBase /></el-icon>热门课程</el-button>
        </span>
    </el-col>

    <el-col :span="10" class="colBorder">
        <span class="courseFont">公告:</span>
        <textarea class="courseValue form-control" rows="6" id="notices" :value=" course && course.notices" :disabled="courseNoticesFlag"></textarea>
    </el-col>
    <el-col :span="1" class="colBorder">
        <span class="disableFont">_</span>
        <el-button type="primary" icon="Edit" class="form-control" v-if="courseNoticesFlag" @click="courseNoticesFlag = false" plain />
        <el-button type="success" icon="Finished" class="form-control" v-if="!courseNoticesFlag" @click="editcourseNotices()" plain />
    </el-col>
    <el-col :span="1" class="colBorder"></el-col>

    <el-col :span="8" class="colBorder">
        <span class="courseFont">课程属性:</span>
        <select
            class="form-select"
            id="isPublic"
            name="isPublic"
            v-model="isPublic"
            :disabled="coursePublicFlag"
            >
            <option value="0" selected>公开课</option>
            <option value="1">私有课</option>
        </select>
    </el-col>
   
    <el-col :span="2" class="colBorder" v-if="isPublic == 1">
        <span class="disableFont">_</span>
        <input type="text" class="form-control" id="addCode" :value="course && course.addCode"/> 
    </el-col>
    <el-col :span="1" class="colBorder">
        <span class="disableFont">_</span>
        <el-button type="primary" icon="Edit" class="form-control" v-if="coursePublicFlag" @click="coursePublicFlag = false" plain />
        <el-button type="success" icon="Finished" class="form-control" v-if="!coursePublicFlag" @click="editCoursePublic()" plain />
    </el-col>
    <el-col :span="1" class="colBorder"></el-col>
  </el-row>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import $ from 'jquery';

const Route = useRoute(); //获取到值
const courseId = ref("");
let course = ref(null);
let courseNameFlag = ref(true);
let courseDesFlag = ref(true);
let coursePublicFlag = ref(true);
let editCourseImgForm = ref(false);
let courseNoticesFlag = ref(true);
let courseImg = ref("");
let isPublic = ref(0);


onMounted(() => {
  courseId.value = Route.params.courseId;
  pullCourse(courseId.value);
});


const pullCourse = (id) => {
    $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/getCourseById",
    data: {
        courseId: id
    },
    type: "post",
    success(resp) {
      course.value = resp.data;
      isPublic.value = course.value.isPublic;

      if (resp.code != "200") {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
        ElMessage({
          type: "error",
          message: "获取课程失败",
        });
    },
  });
}

const editCourseName = () => {
    let name = $("#courseName").val();
    if (name == "") {
        ElMessage({
          type: "error",
          message: "课程名不能为空",
        });
    }

    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/course/editCourseName",
        data: {
            courseName:name,
            courseId:courseId.value
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改课程名失败",
            });
        },
    });

    courseNameFlag.value = true;
    setTimeout(() => {
        pullCourse(courseId.value);
    }, 20); // 20
}

const editcourseNotices = () => {
    let notices = $("#notices").val();
    if (notices == "") {
        ElMessage({
          type: "error",
          message: "公告不能为空",
        });
    }

    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/course/editCourseNotices",
        data: {
            notices: notices,
            courseId:courseId.value
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改公告失败",
            });
        },
    });

    courseNoticesFlag.value = true;
    setTimeout(() => {
        pullCourse(courseId.value);
    }, 20); // 20
}

const editCourseDes = () => {
    let describes = $("#courseDes").val();
    if (describes == "") {
        ElMessage({
          type: "error",
          message: "描述不能为空",
        });
    }

    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/course/editCourseDes",
        data: {
            describes: describes,
            courseId:courseId.value
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改课程描述失败",
            });
        },
    });

    courseDesFlag.value = true;
    setTimeout(() => {
        pullCourse(courseId.value);
    }, 20); // 20
}

const editCourseImg = (img) => {
    editCourseImgForm.value = true;
    courseImg.value = img;
}

const editCourseImgOK = () => {
     // 判断封面
  if ($("#courseImgFile")[0].files.length == 0) {
    ElMessage({
      type: "error",
      message: "课程封面未上传！",
    });
    return false;
  }

  const token = localStorage.getItem("token");

  var formData = new FormData();
  formData.append("file", $("#courseImgFile")[0].files[0]); // 添加课程封面
  formData.append("courseId", courseId.value); // 添加ID
  formData.append("courseImg", $("#courseImg").val()); // 添加ID

  editCourseImgForm.value = false;

  // 创建课程
  $.ajax({
    url: "http://124.222.105.205:5000/api/course/editCourseImg",
    type: "post",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
    },
    processData: false, // 告诉jQuery不要去处理发送的数据
    contentType: false, // 告诉jQuery不要去设置Content-Type请求头
    dataType: "text",
    success: function (resp) {
      let result = JSON.parse(resp);
      if (result.code == "200") {
        ElMessage({
          type: "success",
          message: result.msg,
        });
        pullCourse(courseId.value);
      } else {
        ElMessage({
          type: "error",
          message: result.msg,
        });
      }
    },
    error: function () {
      ElMessage({
        type: "error",
        message: "更改封面失败！",
      });
    },
  });
}

const editCoursePublic = () => {
    coursePublicFlag.value = true;

    let ispublic = $("#isPublic").val();
    let addcode = $("#addCode").val();

    if (ispublic == "1" && (addcode == "" || addcode == null)) {
        ElMessage({
            type: "error",
            message: "加课码未填！",
        });
        return false;
    }

    if (ispublic == 0 && addcode == null) addcode = "";
    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/course/editCoursePublic",
        data: {
            isPublic: ispublic,
            addCode: addcode,
            courseId: courseId.value
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                pullCourse(courseId.value);
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改属性失败",
            });
        },
    });

}

</script>

<style scoped>
.courseFont {
    color: rgb(83, 83, 83);
    font-weight: bold;
    margin: 15px;
    padding: 5px;
}

.courseValue{
    color: rgb(47, 47, 47);
}

.colBorder {
    margin-bottom: 40px;
}

.courseImg {
    width: 300px;
}

.courseBtn {
    padding-left: 0px;
}

.disableFont {
    color: rgba(240, 248, 255, 0);
}

.introBack {
    background-color: rgba(201, 201, 201, 0.055);
    padding: 5px;
}
</style>